<div class="finalize-request">
  <fa-icon [icon]="'exclamation-triangle'" class="iana-icons align-center"></fa-icon>
  <div style="padding-left: 16px;">
    <div *ngIf="isStaffUI" class="grid-x">
      Your edits to this domain have not been submitted yet. Once you are ready for the changes to be processed,
      click "Proceed" to review and submit your changes.
    </div>
    <div *ngIf="!isStaffUI" class="grid-x">
      Your edits to this domain have not been submitted yet. Once you are ready for the changes to be processed,
      click "Finalize Request" to review and submit your request.
    </div>
    <div class="grid-x save-cancel-button-group">
      <button *ngIf="isStaffUI" class="iana-button" (click)="onConfirmChanges()">Proceed</button>
      <button *ngIf="!isStaffUI" class="iana-button" (click)="onConfirmChanges()">Finalize Request</button>
      <button class="iana-button-cancel" (click)="onCancelChanges()">Cancel</button>
    </div>
  </div>
</div>
